module.exports = __webpack_public_path__ + "static/media/Isa.41c432e5.jpeg";